import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    MenuItem,
    ListItemIcon,
    ButtonGroup,
    Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, CheckBox, CheckBoxOutlineBlank, ColorLens, RemoveCircle, Save, Search, SendAndArchive } from '@mui/icons-material';

import { checkComponentPresence, getCategoryColor, getSelectedElement, makeid, myFormat, myTimestampToDate, propComparator, propComparatorDate } from '../utils/ui_utils';
import { globalstyles } from '../lib/definitions';

import DeleteconfirmationSection from '../components/DeleteConfirmationSection';
import { get_Cow_list, update_cows_param } from '../FirebaseUtils/dbCow';
import { useEvent } from '../context/eventContext';
import { category_section, CategoryLabel } from '../definitions/category';
import { getAwardDescription, getAwardLabel, getFilteredList, getPointData } from '../definitions/match';
import { format } from 'date-fns';

import { advance_data_entry, common_data_entry, other_data_entry, mother_data_entry, lifetime_data_entry, getCross } from '../definitions/cow';
import { common_data_entry as cowmancommon_data_entry } from '../definitions/cowman';
import { common_data_entry as propertycommon_data_entry } from '../definitions/property';
import { MyCloseBtn } from '../components/MyButtons';


const export_type_dict = {
    db_export: {
        id: 'db_export',
        label: 'dati gare per database',
        filetype: 'txt',
        type: 'txt/plain',
        txt_separator: '',
        basename: 'datiGareDatabase',
        initData: (ml, cl, ev) => initDbData(ml, cl, ev)
    },
    insurance_export: {
        id: 'insurance_export',
        label: 'soggetti con risultati per assicurazione',
        filetype: 'csv',
        type: 'txt/csv',
        basetitle: 'SOGGETTI',
        basename: 'risultatiPerAssicurazione',
        initData: (ml, cl, ev) => initCsvInsurance(ml, cl)
    },
    catalog_export: {
        id: 'catalog_export',
        label: 'soggetti con numero di catalogo',
        filetype: 'csv',
        type: 'txt/csv',
        basetitle: 'SOGGETTI con numero di catalogo',
        basename: 'soggettiCatalogo',
        initData: (ml, cl, ev) => initCowlistWithCatalog(ml, cl)
    },
    plainmatch_export: {
        id: 'plainmatch_export',
        label: 'dati gare (testo semplice)',
        filetype: 'txt',
        type: 'txt/plain',
        txt_separator: ' ',
        basetitle: 'RISULTATI GARA',
        basename: 'datiGareSemplice',
        initData: (ml, cl, ev) => initPlainMatchList(ml, cl)
    }
}
const format_list = ['dos', 'unix']
const presence_list = [
    { value: false, label: 'nascondi' },
    { value: true, label: 'visualizza' },
]
const csv_separator = [
    { value: ';', label: 'punto e virgola [ ; ]' },
    { value: ',', label: 'virgola [ , ]' },
    { value: '\t', label: 'tab' },
    { value: ' ', label: 'spazio' },
]

const getBirthData = (b) => {
    if (b) {
        return myFormat(b, 'dd/MM/yyyy')
    } else {
        return ''
    }

}


const getCategoryLabel = (c) => {
    if (c) {
        if (c.category_number < 8) {
            return 'M'
        } else {
            return 'V'
        }
    }

}


const SIDE_SIZE = 3

export const ExportDataDialog = forwardRef(({ cow_list }, ref) => {

    const { selEvent } = useEvent()
    const [open, setOpen] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [typeMode, setTypeMode] = useState()
    const [formatMode, setFormatMode] = useState('dos')
    const [showNotPresent, setShowNotPresent] = useState(false)
    const [csvSeparator, setCsvSeparator] = useState(';')
    const [match_list, setMatchList] = useState([])
    useImperativeHandle(ref, () => {
        return {
            onOpen(ml) {
                handleOpen()
                setLoading(false)
                setMatchList(ml)

            }
        }
    })

    const handleOpen = () => {
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleExport = async () => {
        const ft = export_type_dict[typeMode]
        const ev_date = format(myTimestampToDate(selEvent.event_start), 'yyyyMMdd')
        const export_date = format(new Date(), 'yyMMddmmss')
        const end = formatMode === 'dos' ? '\r\n' : '\n'
        const separator = ft.filetype === 'txt' ? ft.txt_separator : csvSeparator
        let export_data = []
        const rd = ft.initData(match_list, cow_list.filter(c => showNotPresent || c.is_present), selEvent)
        const title = `${ft.basetitle} ${!showNotPresent ? 'PRESENTI' : 'TOTALI'} ALLA MOSTRA ${selEvent.event_name} del ${myFormat(selEvent.event_start, 'dd/MM/yyyy')}`
        if (ft.basetitle) {
            export_data = [[title]]
        }
        console.log(export_data)
        export_data = [...export_data, ...rd].map(cell => {
            return cell.join(separator)
        }).join(end)
        console.log("\nEXPORT \n", export_data, "\n\n")
        const blob = new Blob([export_data], { type: ft.type });
        // Generate a download link and initiate the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const location = selEvent.location && selEvent.location.name ? selEvent.location.name : ''
        link.href = url;
        link.download = `stANAFIBJ-${ft.basename}_${ev_date}_${selEvent.id_protocol}_${location}_(${export_date}).${ft.filetype}`;
        // link.download = 'catalogo' + fileName || 'export_data.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        //setOpen(false)
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md">
                <DialogTitle>
                    <b>
                        Esporta dati per altre piattaforme
                    </b>
                </DialogTitle>
                <DialogContent>
                    <Typography style={globalstyles.sectionHeader}>
                        tipo di esportazione
                    </Typography>
                    {Object.values(export_type_dict).map((t, k) => (
                        <Grid key={k} style={globalstyles.list_row} container>
                            <Grid size="auto">
                                <Button size="small" onClick={() => { setTypeMode(t.id); }} variant={typeMode === t.id ? 'contained' : 'outlined'} >
                                    {typeMode === t.id ? <CheckBox /> : <CheckBoxOutlineBlank />}</Button>
                            </Grid>
                            <Grid size="grow">
                                {t.label}
                            </Grid>
                            <Grid size={1}>
                                {t.filetype}
                            </Grid>
                        </Grid>
                    ))}
                    <Typography style={globalstyles.sectionHeader}>
                        opzioni
                    </Typography>
                    <Grid container style={globalstyles.list_row}>
                        <Grid size={SIDE_SIZE}>
                            Formato file
                        </Grid>
                        <Grid size="grow">
                            <ButtonGroup size="small">
                                {format_list.map((f, fk) => (
                                    <Button key={fk} size="small" onClick={() => { setFormatMode(f) }} variant={formatMode === f ? 'contained' : 'outlined'} >
                                        {formatMode === f ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                        {f}
                                    </Button>
                                ))}
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                    <Grid container style={globalstyles.list_row}>
                        <Grid size={SIDE_SIZE}>
                            Soggetti non presenti
                        </Grid>
                        <Grid size="grow">
                            <ButtonGroup size="small">
                                {presence_list.map((f, fk) => (
                                    <Button key={fk} size="small" onClick={() => { setShowNotPresent(f.value) }} variant={showNotPresent === f.value ? 'contained' : 'outlined'} >
                                        {showNotPresent === f.value ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                        {f.label}
                                    </Button>
                                ))}
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                    {typeMode && export_type_dict[typeMode].filetype === 'csv' &&
                        <Grid container style={globalstyles.list_row}>
                            <Grid size={SIDE_SIZE}>
                                Separatore
                            </Grid>
                            <Grid size="grow">
                                <ButtonGroup size="small">
                                    {csv_separator.map((f, fk) => (
                                        <Button key={fk} size="small" onClick={() => { setCsvSeparator(f.value) }} variant={csvSeparator === f.value ? 'contained' : 'outlined'} >
                                            {csvSeparator === f.value ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                            {f.label}
                                        </Button>
                                    ))}
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    }

                </DialogContent>
                <DialogActions>
                    <MyCloseBtn handleClose={handleClose} />
                    <Button disabled={!typeMode} color="secondary" variant="contained" loading={isLoading} onClick={() => handleExport()} startIcon={<SendAndArchive />}>
                        Esporta File
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
})


const initPlainMatchList = (match_list, cow_list) => {
    let export_raw_list = []
    console.log(match_list)
    for (const m of match_list) {
        export_raw_list.push([''],["===", m.match_name,
            '-',
        m.match_description, "==="])
        if (m.match_type === 'auto' || m.status === 'end') {
            for (const r of m.award_list) {
                export_raw_list.push([r.award_name])
                const a = getSelectedElement(r.id, m.result_list, 'id')
                console.log("AWARD result", r.award_name, m, r, a, !a || !a.cow_list)
                let cl = []
                if (a && a.cow_list) {
                    cl = getFilteredList(m.id, m.result_list, m.cow_list, a.id).cow_list
                    console.log("CL", cl)
                    if (cl.length===0){
                            export_raw_list.push([
                                '---'
                            ])

                    }
                    for (const cow of cl) {
                        console.log("_----debug COW", cow)
                        if (cow.cow) {
                            console.log("_----__________", "HAS DATA")
                            const real_cow = getSelectedElement(cow.cow.id, cow_list, 'id')
                            export_raw_list.push([
                                cow.position_id!== undefined?cow.position_id + 1: '',
                                '-',
                                real_cow.catalog_id,
                                real_cow.serial,
                                real_cow.name,
                                ",",
                                getCross(real_cow),
                                ",",
                                real_cow.property?.name
                            ])
                        }
                    }
                } else {
                    const _el = getPointData(m, match_list, cow_list)
                    console.log("NOT COW", _el)
                    if (_el.length > 0) {
                        const _f_el = _el.filter(pr => pr.id === r.id)
                        if (_f_el.length > 0) {
                            cl = _f_el[0].data_list
                            console.log("LIST OTHER", cl)
                            for (const k in cl) {
                                const res = cl[k]
                                export_raw_list.push([
                                    k+1,
                                    res.cdaua || res.cdaua_cowman,
                                    res.name,
                                    res.provincia,
                                    res.total_point + "punti"
                                ])
                            }
                        }
                    }
                }
            }
        } else {
            console.log("NOT Result", m)
            export_raw_list.push(["nessuna risultato presente"])
        }
    }
    return export_raw_list
}

const initCsvInsurance = (match_list, cow_list) => {
    //const end = fm === 'dos' ? '\r' : '\n'
    const data = collectCowResultsData(match_list, cow_list)
    //const insurance_title = `PRESENTI ALLA MOSTRA ${selEvent.event_name} del ${myFormat(selEvent.event_start, 'dd/MM/yyyy')}`
    const csvString = [
        //  [insurance_title],
        ['PROPRIETARIO', 'NUMCAT', 'MATRICOLA SOG.', 'DATANASC.', 'RANK', 'CATEGORIA', 'pft'],
        ...data.map(cow => [
            cow.property ? cow.property.cdaua : '',
            cow.catalog_id,
            cow.serial,
            getBirthData(cow.birthdate),
            cow.total_point,
            getCategoryLabel(cow.category),
            cow.pft
        ]) // Map your data fields accordingly
    ]
    return csvString

    /*             .map(row => row.join(","))
                .join(end);
            const blob = new Blob([csvString], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'export_data.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); */

}

const initDbData = (match_list, cow_list, cur_event) => {
    const ev_date = format(myTimestampToDate(cur_event.event_start), 'yyyyMMdd')
    const data = collectCowResultsData(match_list, cow_list)
    let txt_data = []
    for (const cow of data) {
        //const real_cow = getSelectedElement(cow, cow_list, 'id')
        //console.log("COW", cow, real_cow)
        if (cow.id) {
            const c_data = [
                cow.breed,
                cow.serial,
                ev_date,
                cur_event.event_category,
                cur_event.location?.address_cap,
                `${cow.catalog_id}`.padStart(4, '0'),
                category_section[cow.category?.category_number],
                `${cow.category?.category_number}`.padStart(2, '0'),
                `${cow.property?.cdaua}`.padStart(7, '0'),
                cur_event.location?.address_state_short,
                `${cow.total_point}`.padStart(4, '0'),
                cow.export_description]
            //console.log(c_data)
            txt_data.push(c_data)
        }
    }
    return txt_data
}


const initCowlistWithCatalog = (match_list, cow_list) => {
    const mapdatacow_dict = Object.assign({}, ...[...common_data_entry, ...advance_data_entry, ...other_data_entry, ...lifetime_data_entry, ...mother_data_entry].filter(e => e.import_id).map((x) => ({ [x.id]: { label: x.import_id, type: x.type } })))
    //    const mapdatacowman_dict = Object.assign({}, ...[...cowmancommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))
    const mapdatacowman_dict = Object.assign({}, ...[...cowmancommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.id]: { label: x.import_id, type: x.type } })))
    //    const mapdataproperty_dict = Object.assign({}, ...[...propertycommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))
    const mapdataproperty_dict = Object.assign({}, ...[...propertycommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.id]: { label: x.import_id, type: x.type } })))
    //    const title = 'soggetti con numero di catalogo'
    const csvString = [
        //       [title],
        ['catalogo',
            ...Object.values(mapdatacow_dict).map(c => c.label),
            ...Object.values(mapdatacowman_dict).map(c => c.label),
            ...Object.values(mapdataproperty_dict).map(c => c.label),
        ],
        ...cow_list.sort(propComparator('catalog_id')).map(cow => {

            let c_list = [cow.catalog_id || '']
            for (const cp in mapdatacow_dict) {
                const p = mapdatacow_dict[cp]
                let v = ''
                if (cow[cp]) {
                    if (p.type === 'date') {
                        v = myFormat(cow[cp])
                    } else {
                        if (p.type === 'switch') {
                            if (cow[cp] === 'red') {
                                v = 'R'
                            }
                        } else {
                            v = cow[cp]
                        }
                    }
                }
                c_list.push(v)

            }
            console.log("PARTIAL ", c_list)
            for (const ccp in mapdatacowman_dict) {
                let v = ''
                console.log("COWMAN", cow.cowman, ccp)
                if (cow.cowman && cow.cowman[ccp]) {
                    v = cow.cowman[ccp]
                }
                c_list.push(v)
            }
            for (const ccp in mapdataproperty_dict) {
                let v = ''
                if (cow.property && cow.property[ccp]) {
                    v = cow.property[ccp]
                }
                c_list.push(v)
            }
            return c_list
        })
    ]
    return csvString
    /*             .map(cell => cell.join(";"))
                .join(end);
            console.log(csvString)
            const blob = new Blob([csvString], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'catalogo' + fileName || 'export_data.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); */
}



const collectCowResultsData = (match_list, cow_list) => {
    let cow_dict = {}
    let _cow_list = []
    for (const m of match_list) {
        console.log("MATCH", m)
        if (m.link_to_category) {

        }
        if (m.use_dynamic_list) {

        }
        if (m.match_type === 'normal' && m.result_list) {
            for (const r of m.result_list) {
                console.log("result list", r)
                if (r && !r.from_other_data) {
                    const award = getSelectedElement(r.id, m.award_list, 'id')
                    console.log("pre---AWARD", award)
                    let c_list = r.cow_list.map((c, k) => {
                        if (!award.has_position) {
                            console.log("AWARD", award)
                        }
                        console.log(c.cow && (m.overflow_as_limit || k < m.export_position_limit))
                        if (c.cow && (m.overflow_as_limit || parseInt(m.export_position_limit) === 0 || k < m.export_position_limit)) {
                            const cow = getSelectedElement(c.cow.id, cow_list, 'id')
                            if (!cow_dict[c.cow.id]) {
                                cow_dict[c.cow.id] = { ...cow, total_point: 0, export_description: '' }
                            }
                            const als = getAwardLabel(c.position_id, m.award_label_list, true)
                            const t_point = award.point_list && award.point_list[k] ? award.point_list[k] : 0
                            const data = {
                                cow: cow,
                                match_point: t_point,
                                award_description: award.has_position ? getAwardDescription(m, c.position_id, als, m.match_shortname) : 'MIG.MAM.,',
                                match_data: {
                                    name: m.match_name,
                                    shortname: m.match_shortname,
                                    award: award.award_name,
                                    has_position: award.has_position,
                                    award_label: getAwardLabel(c.position_id, m.award_label_list),
                                    award_shortlabel: als,
                                    position_id: c.position_id,
                                    position: k
                                }
                            }
                            cow_dict[cow.id].total_point += t_point
                            cow_dict[cow.id].export_description += data.award_description
                            console.log("ALS", als, data,)
                            return data

                        } else {
                            return undefined
                        }
                    }).filter(c => c !== undefined)
                    _cow_list = [..._cow_list, ...c_list]
                }
            }
        }

    }
    return Object.values(cow_dict)
    //    return cow_dict
}